module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAJCAYAAAA/33wPAAAA/UlEQVQokZ3RPyuGURzG8c9zM/AOSJmMJnWnGBHeAvEOmKwURoNS3gA2gyj/siiL574nmwwGJRY2yn/96jz1lHvQcy2nrnPO93ed69SKonjEKja1pnksZtjHBqZbwMxgHbsBmsMhtoOMtn8A2rGCLexFqgC9YzkdiM06JpBVALK0V09DQ5d5nn8GuS8lusZSgh0jujvDbUrZizF04wrDmMJaWZYPUfYBBjCEuzR1FEd4xg9q+EIXxtOAhr+D/ki0gLcECX3jPqWYxUnyB+MZqYqAhGKNwjsCdFPRxQg+cNHklXjCJM4bZp7nMfi1qtBQD07x0uTFhfilzj+n8QsWG0A6l11FKQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/bxsmm.png
// module id = /lUc
// module chunks = 1